import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from '@mui/material/'
import styled from 'styled-components/macro'
import { useLocation, useNavigate } from 'react-router-dom'

const StyledBreadcrumbs = styled(MUIBreadcrumbs)`
    padding: 0.5rem 0 0 1rem;
`
const StyledLink = styled(Link)`
    text-decoration: none;
    cursor: pointer;
`

export default function Breadcrumbs() {
    let { pathname }: any = useLocation()
    let navigate = useNavigate()
    const pathnames = pathname.split('/').filter((x: any) => x)

    return (
        <StyledBreadcrumbs>
            {pathnames.length > 0 ? <StyledLink onClick={() => navigate('/')}>Start</StyledLink> : <Typography> Start </Typography>}
            {pathnames.map((name: any, index: any) => {
                const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`
                const isLast = index === pathnames.length - 1

                return isLast ? (
                    <Typography key={name}>{name}</Typography>
                ) : (
                    <StyledLink key={name} onClick={() => navigate(routeTo)}>
                        {name}
                    </StyledLink>
                )
            })}
        </StyledBreadcrumbs>
    )
}
